/* global _networkPingUrl_ */
import UrlParser from 'url-parse';

let autoRefreshInstance = null;

class pageRefresh {
    constructor(params) {
        this.timer = null;
        //if auto-refresh is disabled there is no params defined
        if (params) {
            this.time = params.time;
            this.urlToRefresh = params.urlToRefresh;
            this.uniq = params.uniq;
        }
    }
    start() {
        if (this.timer || this.time === 0) {
            // timer already running or user set refresh to never (0)
            return this;
        }
        else {
            // console.info('start autorefresh');
            this.timer = setInterval(() => {
                checkOnlineStatus()
                    .then(() => {
                        const routesToExclude = [
                            '/compose',
                            '/reply',
                            '/forward',
                            '/draft'

                        ];
                        if (routesToExclude.some(route => window.location.pathname.startsWith(route))) {
                            return;
                        }

                        //if CMP banner is shown, do not refresh the page
                        if (document.querySelector('.stpd_cmp_form')) {
                            return;
                        }

                        location.href = `${window.location.href}&uniq=${this.uniq}`;

                        location.reload();
                    });
            }, this.time * 1000);
        }
        return this;
    }
    stop() {
        if (this.timer === null) {
            return this;
        }
        // console.log('stop timer');
        clearInterval(this.timer);
        this.timer = null;
        return this;
    }
}

/**
 * ASCII to Unicode (decode Base64 to original data)
 * @param {string} b64
 * @return {string}
 */
export const atou = (b64) => decodeURIComponent(escape(atob(b64)));

/**
 * Unicode to ASCII (encode data to Base64)
 * @param {string} data
 * @return {string}
 */
export const utoa = (data) => btoa(unescape(encodeURIComponent(data)));

/**
 * Convert to uppercase first letter of string
 * @param {string} str
 * @returns {string}
 */
export const capitalize = (str) => {
    if (typeof str !== 'string') return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
};

export const countQuickButtonClickForGA = (eventLabel) => {
    if (window.ga) {
        window.ga('otherTracker.send', 'event', 'ButtonClick', '3button', eventLabel, 1);
    }
};

export const createDeferredPromise = () => {
    let resolve, reject;
    const promise = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
    });

    return { promise, resolve, reject };
};

export const detectType = (argument) => {
    if (typeof argument === 'string') {
        return 'String';
    } else if (Array.isArray(argument)) {
        return 'Array';
    } else if (typeof argument === 'object' && argument !== null) {
        return 'Object';
    } else {
        return 'Unknown';
    }
};

export const domContentLoaded = (callBack) => {
    document.readyState === 'loading'
        ? document.addEventListener('DOMContentLoaded', callBack)
        : callBack();
};

export const insertDiv = (id) => {
    if (document.getElementById(id)) return;
    document.body.insertAdjacentHTML('beforeend', `<div id="${id}" hidden></div>`);
};

export const isObjectEmpty = (obj) => {
    return obj && obj.constructor === Object && Object.keys(obj).length === 0;
};

export const pageAutoRefresh = (params) => {
    if (autoRefreshInstance === null) {
        autoRefreshInstance = new pageRefresh(params);
    }
    return autoRefreshInstance;
};

export const checkOnlineStatus = (urlToCheck = _networkPingUrl_) => {
    return $.ajax({
        crossDomain: true,
        url: urlToCheck
    }).promise();
};

export const getComputedFontSize = (selector = 'body') => {
    const style = window.getComputedStyle(document.querySelector(selector));
    return parseInt(style.getPropertyValue('font-size'));
};

export const isProductionMode = () => {
    return (!process.env.NODE_ENV || process.env.NODE_ENV === 'development')
        ? false
        : true;
};

export const listContainsChar = (list) => (char) => list.indexOf(char) !== -1;

// NOTE: ad blockers do not catch popups if a generator function is used
export function* windowOpen(baseUrl) {
    const newWin = window.open(baseUrl);
    const file = yield;
    if (newWin.document.readyState === 'complete') {
        newWin.location = file;
    }
    else {
        newWin.onload = () => {
            newWin.location = file;
        };
    }
}

let composeWin = null;
export const openComposeWin = (mailUrl, path) => {
    if (composeWin !== null && !composeWin.closed) {
        composeWin.focus();
        return;
    }
    const now = new Date();
    const name = 'compose_windows_' + now.getTime();
    let url;

    if (mailUrl.length > 0) {
        url = `${path}?${mailUrl}&popup=1&uniq=${now.getTime()}`;
    }
    else {
        url = `${path}?popup=1&uniq=${now.getTime()}`;
    }
    const param = 'toolbar=no,location=no,status=yes,scrollbars=yes,resizable=yes,width=965,height=700,left=0,top=0';

    composeWin = window.open(url, name, param);
    composeWin.opener = self;
    //MAIL-6104 - caused console warning on firefox, functionality is working fine and focused
    // composeWin.focus();
};

let printWindow = null;
export const openPrintWin = (path) => {
    if (printWindow !== null && !printWindow.closed) printWindow.close();

    const now = new Date();
    const name = 'print_windows_' + now.getTime();
    const url = `${path}&uniq=${now.getTime()}`;
    const param = 'toolbar=yes,location=no,status=yes,scrollbars=yes,resizable=yes,width=800,height=700,left=0,top=0';
    printWindow = window.open(url, name, param);
    printWindow.opener = self;
};

export const openPopupLink = (url) => {
    // console.log(url);
    const parsedUrl = new UrlParser(url, true);
    const queryString = parsedUrl.toString().split('?').pop();

    openComposeWin(queryString, parsedUrl.pathname);
};

export const getCurrComposeLink = () => {
    const searchParams = new URLSearchParams(window.location.search);
    //MAIL-6382 - Need to save all parameters to return to the current mailbox page with parameters after a successful send
    return { path: '/compose', search: searchParams.toString() };
};

export const getCurrentIndex = (object, key) => {
    if (!object) return 1;
    const obj = object.find(x => x.msguid === key);

    return object.indexOf(obj) + 1;
};

export const getItem = (object, key, i, params, isLastOrFirst) => {
    if (!object || isNaN(key)) return false;

    const obj = object.find(x => x.msguid === key);
    if (params === 'current') return obj;

    let index = object.indexOf(obj);
    if (params === 'next' && isLastOrFirst) {
        return object[0];
    }
    if (params === 'prev' && isLastOrFirst) {
        return object[object.length - 1];//last msg in list from prev page
    }
    if (index + 1 === object.length) {
        return object[index - 1];
    }
    if ((i === -1 && index > 0) || (i === 1 && index < object.length - 1)) {
        index += i;
    }

    return object[index];
};

export const getCurrentFolderFromUrl = (customSearchParams = null) => {
    const searchParams = new URLSearchParams(customSearchParams ?? window.location.search);
    let currentFolder = searchParams.get('mailbox') && searchParams.get('mailbox') !== 'null' ? searchParams.get('mailbox') : 'INBOX';
    currentFolder = currentFolder.replace('%2F', '/');
    // MAIL-6385 - removed symbol ",", to allow open specific cases when user syncs folders and it have symbol ","
    const forbiddenSymbols = /[!@#$%^*()|\\[\]{}<>"'?/+]/;
    if (forbiddenSymbols.test(currentFolder.replace(/\//g, ''))) return 'INBOX';
    if (currentFolder.endsWith('/')) currentFolder = currentFolder.slice(0, -1);

    return currentFolder;
};

export const getCurrentActionFromUrl = () => {
    const pathName = window.location.pathname;
    if (pathName.startsWith('/reply/all')) return 'reply_all';
    if (pathName.startsWith('/reply')) return 'reply';
    if (pathName.startsWith('/forward')) return 'forward';
    if (pathName.startsWith('/draft')) return 'draft';

    return 'no_action';
};

export const isComposeUrlContains = () => {
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has('share_uuid')) {
        const shareUuid = searchParams.get('share_uuid');
        const files = [];
        searchParams.forEach((value, key) => {
            const matches = key.match(/(files)\[(\d+)\]\[(id|name)\]/);
            if (matches && matches.length === 4) {
                const fileIndex = matches[2];
                const fileType = matches[3];
                if (!files[fileIndex]) {
                    files[fileIndex] = {};
                }
                files[fileIndex][fileType] = value;
            }
            if (!matches && key.includes('folder')) { //handle folder share
                files['folder'] = value;
            }
        });
        return { share_uuid: shareUuid, files };
    }
    if (searchParams.has('foto_share')) {
        const album = [];
        const photo = [];
        searchParams.forEach((value, key) => {
            const matches = key.match(/(album|foto)\[(\w+)\]/);
            if (matches && matches[1] === 'album') {
                if (!album[matches[2]]) {
                    album[matches[2]] = {};
                }
                album[matches[2]] = value;
            } else if(matches) {
                if (!photo[matches[2]]) {
                    photo[matches[2]] = {};
                }
                photo[matches[2]] = value;
            }
        });
        return { album, photo };
    }
    return null;
};

// a function to retry loading a chunk to avoid chunk load error for out of date code
export const lazyRetry = function (componentImport, name) {
    return new Promise((resolve, reject) => {
        // check if the window has already been refreshed
        const hasRefreshed = JSON.parse(
            window.sessionStorage.getItem(`retry-${name}-refreshed`) || 'false'
        );
        // try to import the component
        componentImport().then((component) => {
            window.sessionStorage.setItem(`retry-${name}-refreshed`, 'false'); // success so reset the refresh
            resolve(component);
        }).catch((error) => {
            if (!hasRefreshed) { // not been refreshed yet
                window.sessionStorage.setItem(`retry-${name}-refreshed`, 'true'); // we are now going to refresh
                reject(error);
                console.error(error);
                return window.location.reload(); // refresh the page
            }
        });
    });
};

// MAIL-6318 checks if browser allows shadowDOM (specific case - mypal v29 not supporting)
export const supportsShadowDOM = !!HTMLElement.prototype.attachShadow;